import { render, staticRenderFns } from "./DashboardChartLogins.vue?vue&type=template&id=6687d138&"
import script from "./DashboardChartLogins.vue?vue&type=script&lang=js&"
export * from "./DashboardChartLogins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports